/**
 * O Guia do MGDLead — índice do conteúdo.
 *
 * Estrutura: capítulo → seção → passo (ver `tipos.ts`). O texto mora em três arquivos, por
 * assunto, e este junta tudo na ordem de leitura:
 *
 *  - `conteudo-inicio.ts`  — Primeiros passos (tutorial do primeiro usuário) e Conexões;
 *  - `conteudo-abas.ts`    — um capítulo por aba do menu;
 *  - `conteudo-numeros.ts` — cada métrica, o que roda sozinho e as dúvidas frequentes.
 *
 * As imagens são capturas reais geradas por `apps/web/scripts/guia-capturas.mjs`.
 */
import { CAPITULOS_DAS_ABAS } from './conteudo-abas';
import { CONEXOES, PRIMEIROS_PASSOS } from './conteudo-inicio';
import { AUTOMATICO, DUVIDAS, METRICAS } from './conteudo-numeros';
import type { CapituloDoGuia } from './tipos';

export interface GrupoDoGuia {
  id: string;
  titulo: string;
  descricao: string;
  capitulos: readonly CapituloDoGuia[];
}

export const GRUPOS_DO_GUIA: readonly GrupoDoGuia[] = [
  {
    id: 'comece',
    titulo: 'Comece aqui',
    descricao: 'Do cadastro ao primeiro custo por entrada, e as três conexões.',
    capitulos: [PRIMEIROS_PASSOS, CONEXOES],
  },
  {
    id: 'abas',
    titulo: 'Cada aba do painel',
    descricao: 'O que é, cada botão e opção, e o que dá para fazer em cada tela.',
    capitulos: CAPITULOS_DAS_ABAS,
  },
  {
    id: 'numeros',
    titulo: 'Entender os números',
    descricao: 'Cada métrica explicada, o que é automático e as dúvidas mais comuns.',
    capitulos: [METRICAS, AUTOMATICO, DUVIDAS],
  },
];

/** Todos os capítulos, na ordem de leitura. */
export const CAPITULOS: readonly CapituloDoGuia[] = GRUPOS_DO_GUIA.flatMap((g) => g.capitulos);

export function capituloPorId(id: string | undefined): CapituloDoGuia | undefined {
  return CAPITULOS.find((c) => c.id === id);
}

/** Caminho do guia dentro do workspace. */
export function caminhoDoGuia(slug: string, capituloId?: string, ancora?: string): string {
  const base = `/w/${slug}/treinamentos/guia`;
  if (!capituloId) return base;
  return `${base}/${capituloId}${ancora ? `#${ancora}` : ''}`;
}
